import React, { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { Location } from 'history'

import IOSTransition from './IOSTransition'

interface ArtboardsTransitionProps {
  isBack: boolean
}

type ReversedTransitionType =
  | 'fromRight'
  | 'fromLeft'
  | 'fromTop'
  | 'fromBottom'
  | 'none'

const isNoneTransition = (transaction: string) => transaction === 'none'

const reversedTransition = {
  fromRight: 'fromRightReverse',
  fromLeft: 'fromLeftReverse',
  fromTop: 'fromTopReverse',
  fromBottom: 'fromBottomReverse',
  none: 'none',
}

type TransitionType = keyof typeof reversedTransition

interface LocationState {
  transitionType?: TransitionType
}

let previousLocation: Location | null = null
let previousTransition: ReversedTransitionType = 'none'

const ArtboardsTransition: FC<ArtboardsTransitionProps> = ({
  children,
  isBack,
}) => {
  const location = useLocation<LocationState>()

  const transition = location?.state?.transitionType ?? 'none'
  const newTransition = isBack
    ? reversedTransition[previousTransition]
    : transition

  if (location.key !== previousLocation?.key) {
    previousLocation = location
    previousTransition = transition
  }

  return (
    <IOSTransition
      transitionKey={
        isNoneTransition(previousTransition) &&
        isNoneTransition(transition) &&
        !previousTransition
          ? 0
          : location.key
      }
      transition={newTransition}>
      {children}
    </IOSTransition>
  )
}

export default ArtboardsTransition
